import { hasStringKey } from "@/utils/misc";
import { LABEL_TEXT, TOOLTIP_TEXT } from "./constants";
import Label from "@ingka/label";
import LabelWithToolTip from "@/components/LabelWithTooltip/LabelWithToolTip";
import { CustomSelect } from "@/components/CustomSelect/CustomSelect";
import InputTextField from "@/components/InputTextField/InputTextField";
import { useMetadataFields } from "@/components/MetadataFields/hooks";
import {
  FieldAccessContext,
  isLockedForNonIngkaUser,
  isLockedForOwner,
  isProducedByLocalOrAgency,
  isUploadFinalized,
} from "@/components/MetadataFields/formFieldsAccessRules";

type Props = {
  fieldAccessContext: FieldAccessContext;
  options: Record<string, string>;
};

const Subdelivery = ({ options, fieldAccessContext }: Props) => {
  const {
    getValidationError,
    activeAsset,
    updateMetadata,
    isMetadataUpdating,
  } = useMetadataFields();

  const error =
    getValidationError("subDelivery", activeAsset.id!) ||
    getValidationError("userSubDelivery", activeAsset.id!);

  const isUpdating =
    isMetadataUpdating(activeAsset.id!, "subDelivery") ||
    isMetadataUpdating(activeAsset.id!, "userSubDelivery");

  const ctx = { ...fieldAccessContext, producedBy: activeAsset.producedBy };
  const isDisabled =
    isLockedForOwner(fieldAccessContext) ||
    isUploadFinalized(ctx) ||
    isLockedForNonIngkaUser(ctx) ||
    isProducedByLocalOrAgency(ctx) ||
    isUpdating;

  const selectedValue = activeAsset.subDelivery || "";

  return (
    <>
      {fieldAccessContext.isAdmin ? (
        <>
          <Label
            htmlFor="admin-sub-delivery-id"
            label={
              <LabelWithToolTip
                labelText={LABEL_TEXT}
                toolTipText={TOOLTIP_TEXT}
              />
            }
          />
          <CustomSelect
            id="admin-sub-delivery-id"
            disabled={isDisabled}
            errorMessage={error?.message}
            value={{ label: options[selectedValue], value: selectedValue }}
            helperMessage={
              activeAsset.userSubDelivery
                ? `User input: ${activeAsset.userSubDelivery}`
                : ""
            }
            options={Object.entries(options).map(([value, label]) => ({
              value,
              label,
            }))}
            onChange={(option) => {
              if (hasStringKey("value", option)) {
                updateMetadata({
                  subDelivery: option.value,
                });
              }
            }}
          />
        </>
      ) : (
        <InputTextField
          id="user-sub-delivery-id"
          labelText={LABEL_TEXT}
          toolTipText={TOOLTIP_TEXT}
          initialValue={activeAsset.userSubDelivery || ""}
          disabled={isDisabled}
          shoudlValidate={Boolean(error)}
          errorMessage={error?.message}
          onBlur={(value: string) =>
            updateMetadata({
              userSubDelivery: value,
            })
          }
        />
      )}
    </>
  );
};

export default Subdelivery;
